export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImZkMDNkYTVhLTY5ZjAtMTFlNi04MGQ0LTAwMTU1ZDYyNDgwYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.sNHu+ZU9RMStETJwfWE+GIrXbfPJbQpzYzj2CiEmuimXmZI/CQ8LVbvjWnwHWVvLK+rQvpr1InpR3PwDwCNMEWCoUcgrGPt9hkfu4DwdpIl0mBDnaHEfLFabBCB+W+Zv4xEVKg==";
